/**
 * Constantes de la aplicación
 */
export class Constants {
  /** url para obtener información del usuario */
  static securityUserInfo = '/cargamasivaemp/security/user';

  /** url para conocer si un usuario tiene permiso hacia un recurso */
  static securityUserAccess = '/cargamasivaemp/security/access';

  /** url para comprobar que un usuario tenga activa una sesión y en caso contrario
   *  obtener el html del formulario de login
   */
  static securityCheckStatus = '/cargamasivaemp/user/check';

  /** url para obtener la URL de logout */
  static securityLogoutUrl = '/cargamasivaemp/logout';
}
